"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToNDecimalPlaces = void 0;
const assert_1 = __importDefault(require("assert"));
/**
 * Rounds a number to a certain number of decimal places
 */
const roundToNDecimalPlaces = (numberToRound, decimalPlaces) => {
    (0, assert_1.default)(decimalPlaces >= 0, `decimalPlaces must be 0 or more for roundToNDecimalPlaces`);
    const adjuster = 10 ** decimalPlaces;
    return Math.round(numberToRound * adjuster) / adjuster;
};
exports.roundToNDecimalPlaces = roundToNDecimalPlaces;
